import { customInstance } from "config/mutator";

import type { ClientStrategyCategoryDTOStrategyCategory } from "generated/schemas";

export type ClientStrategySchemaParams = {
  strategyCategory: ClientStrategyCategoryDTOStrategyCategory;
};

export const getClientStrategySchema = async ({
  strategyCategory,
}: ClientStrategySchemaParams): Promise<unknown> =>
  customInstance<unknown>({
    url: `/api/strategy/schemas/${strategyCategory}`,
    method: "GET",
  });
